import * as React from "react";
import "./styles.css";
import PropTypes from "prop-types";
import {useTheme} from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import {Card, Divider, FormControl, Grid, InputLabel, MenuItem, Select} from "@mui/material";
import LightGallery from "lightgallery/react";
// import styles
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";
import "lightgallery/css/lg-autoplay.css";
import "lightgallery/css/lg-fullscreen.css";
import "lightgallery/css/lg-share.css";
import "lightgallery/css/lg-rotate.css";

// import plugins if you need
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import lgAutoplay from "lightgallery/plugins/autoplay";
import lgFullscreen from "lightgallery/plugins/fullscreen";
import lgShare from "lightgallery/plugins/share";
import lgRotate from "lightgallery/plugins/rotate";
// import image from "../../assets/images";
// import img1 from "../../assets/images/1.jpg";
// import img2 from "../../assets/images/2.jpg";
// import {
//     one,
//     two,
//     ten,
//     eleven
//   } from '../../assets/images'

export const one = require("../../assets/images/BNT_Images/BNT_1.jpg");
export const two = require("../../assets/images/BNT_Images/BNT_2.jpg");
export const three = require("../../assets/images/BNT_Images/BNT_3.jpg");
export const four = require("../../assets/images/BNT_Images/BNT_4.jpg");
export const five = require("../../assets/images/12.jpg");
export const six = require("../../assets/images/BNT_Images/BNT_4.jpg");

// function importAll(r) {
//     let images = {};
//     r.keys().map(item => { images[item.replace('../../', '')] = r(item); });
//     return images;
// }

// const images = importAll(require.context('../../assets/images', false, '/\.jpg/'));

const images = [
  {src: one, alt: "Flag of India"},
  {src: two, alt: "2"},
  {src: three, alt: "3"},
  {src: four, alt: "4"},
//   {src: five, alt: "5"},
//   {src: six, alt: "6"}
  // { src: "/7.jpg", alt: "7", },
  // { src: "/8.jpg", alt: "8", },
  // { src: "/9.jpg", alt: "9", },
  // { src: "/10.jpg", alt: "10", },
  // { src: "/11.jpg", alt: "11", },
  // { src: "/12.jpg", alt: "12", },
  // { src: "/13.jpg", alt: "13", },
  // { src: "/14.jpg", alt: "14", },
  // { src: "/15.jpg", alt: "15", },
  // { src: "/16.jpg", alt: "16", },
  // { src: "/17.jpg", alt: "17", },
  // { src: "/18.jpg", alt: "18", },
  // { src: "/19.jpg", alt: "19", },
];

export default function Gallery() {
  // const theme = useTheme();
  const onInit = () => {
    console.log("lightGallery has been initialized");
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        <AppBar position="static">
          <Card>
            <MDBox pt={4} pb={3} px={3}>
              <LightGallery
                onInit={onInit}
                speed={500}
                plugins={[lgThumbnail, lgZoom, lgAutoplay, lgFullscreen, lgRotate, lgShare]}
              >
                {images.map((image, index) => {
                  return (
                    <a href={image.src} key={index}>
                      <img alt={image.alt} src={image.src} className="img" />
                    </a>
                    //  <img src={image.src} key={index} />
                  );
                })}
              </LightGallery>
            </MDBox>
          </Card>
        </AppBar>
      </MDBox>
    </DashboardLayout>
  );
}
